export const SWITCH_MAC_ACL_SECTION_EVENT =
	'canvas-agent:switch-mac-acl:section';
export const SWITCH_MAC_ACL_FOCUS_EVENT =
	'canvas-agent:switch-mac-acl:focus';
export const SWITCH_MAC_ACL_FILTER_EVENT =
	'canvas-agent:switch-mac-acl:filter';
export const SWITCH_MAC_ACL_CREATE_MODAL_EVENT =
	'canvas-agent:switch-mac-acl:create-modal';
export const SWITCH_MAC_ACL_DELETE_MODAL_EVENT =
	'canvas-agent:switch-mac-acl:delete-modal';
export const SWITCH_MAC_ACL_ADD_ACE_EVENT =
	'canvas-agent:switch-mac-acl:add-ace';
export const SWITCH_MAC_ACL_EDIT_ACE_EVENT =
	'canvas-agent:switch-mac-acl:edit-ace';
export const SWITCH_MAC_ACL_DELETE_ACE_EVENT =
	'canvas-agent:switch-mac-acl:delete-ace';
